var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trending-top-latest-wrapper"},[_c('div',{staticClass:"filters-wrapper"},_vm._l((_vm.ttl),function(item,index){return _c('div',{key:index,staticClass:"filter",class:index === _vm.selectedTtl ? 'selected' : 'unselected',on:{"click":function($event){return _vm.setTtlIndex(index)}}},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }